'use client';
import React, { useState } from 'react';
import { Container, Row, Col, Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import assets from '../../assets/assets';
import { FiArrowDown , FiArrowUp} from 'react-icons/fi';
const FAQ = () => {
  const [openSection, setOpenSection] = useState(null);
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleSection = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

 
  const faqSections = [
    {
      id: 'section1',
      title: 'GENERAL QUESTIONS',
      description: '',
      subSections: [
        {
         
          questions: [
            {
              q: "Why should I book my trip through a tour operator instead of planning on my own?",
              a: "Travel demand—leisure, business, corporate or honeymoon—has returned to pre-pandemic levels. As your trusted travel advisor, we prioritise your safety, comfort and confidence. Our clients depend on us to manage every detail, saving time, money and stress while securing perks, upgrades and priority support. From flight delays and overbooking to hotel mishaps or weather disruptions, our experienced team at Sha tours intervenes quickly and decisively—so you can relax knowing someone reliable is taking care of you."
            },
            {
              q: "How do travellers benefit from using a professional tour operator?",
              a: "A professional tour operator is your behind-the-scenes team, managing reservations, logistics and on-the-ground support for leisure, corporate and group travel. We secure upgrades and perks, handle changes or disruptions, and coordinate hotels, flights and ground transport. Reachable by phone or email, we offer 24/7 after-hours emergency support worldwide. Using a tour operator saves time, reduces stress and ensures smoother, more rewarding trips."
            },
            {
              q: "How can a tour operator reduce the time, I spend on travel planning and arrangements?",
              a: "Searching multiple airline and hotel websites can easily consume hours as you compare prices, options and availability. A tour operator eliminates this wasted time. Simply share your destination, budget and expectations, and we prepare a tailored itinerary for your review and approval. From planning to the end of your trip, we monitor every detail, manage any changes and ensure your journey stays smooth and stress-free."
            },
            {
              q: "What cost benefits can I expect when using a tour operator?",
              a: "A professional tour operator gives you access to exclusive savings, connections and perks not available to the general public. While you may visit a hotel once, we book thousands of rooms annually earning preferred relationships and added benefits. From complimentary breakfasts and spa or dining credits to early check-in, room upgrades and special welcome amenities, our partnerships ensure greater value and a more rewarding travel experience."
            },
            {
              q: "Is booking through a tour operator more cost-effective than planning it on my own?",
              a: "We offer competitive rates by booking directly with hotels and suppliers. Bespoke travel isn't cheap because every trip is handcrafted from years of local knowledge and trusted relationships. No two itineraries are identical: we fine-tune every detail, add insider experiences and provide 24/7 support, logistics and on-ground management. Our premium reflects the expertise, time and care we invest to deliver seamless, memorable travel—truly worth the value."
            },
            {
              q: "I enjoy researching destinations, hotels and food—planning is part of the fun. Should I still consider using a tour operator?",
              a: "Absolutely, planning is part of the joy. Whether you have exact hotels and activities in mind or just a destination, we handle bookings and logistics precisely. Tell us your preferences and budget; we'll present curated options and confirm details. You decide how involved to be hands on or fully hands off while we ensure smooth execution, timely support and worry-free travel."
            },
            {
              q: "What are the key components of a holiday package?",
              a: "Holiday package components commonly include: (a) Land package — accommodation, transfers and sightseeing (any combination or single service, plus optional extras such as meals, guides or excursions); (b) Air tickets; (c) Visa assistance; (d) Travel insurance. You may book individual services or combine them into a tailored package."
            },
            {
              q: "What exactly are Tailor-Made, Customized or FIT holidays?",
              a: "FIT (Free Independent Traveller), tailor-made or customized holidays are trips planned to your exact preferences—dates, destinations, pace and activities—rather than fixed-group departures. They offer full flexibility and personalised itineraries; accommodation and services tailored to your needs."
            },
            {
              q: "What advantages come with a customized or tailor-made holiday?",
              a: "A tailor-made holiday gives you a fully personalised experience instead of a one-size-fits-all itinerary. We guide you in selecting destinations, accommodations, activities and the ideal travel pace, ensuring every element suits your preferences. With expert planning, you avoid surprises, use your time efficiently and make the most of your budget while enjoying a trip designed uniquely for you."
            },
            {
              q: "What services are available under FIT, Tailor-Made or Customized Holidays?",
              a: "FIT / tailor-made holidays can include air tickets, accommodation, airport or station transfers, local / domestic flights, sightseeing, excursions, car hire, guides, activities, visas and travel insurance. You can book any single service or combine several into a personalised package. We also arrange special requests — group arrangements, event access, dietary needs and accessibility support — to match your exact preferences and budget."
            },
            {
              q: "What is a Group Tour?",
              a: "A Group Tour is a packaged trip for multiple travellers, ideal for families, friends, schools or corporate groups. We offer a variety of curated itineraries with inclusive logistics—accommodation, transfers, sightseeing—and a professional guide or group leader. Group tours are cost-effective, social and stress-free, with fixed departures, planned activities and on-ground support for a seamless, memorable shared experience."
            },
            {
              q: "What advantages do groups get when booking an FIT package?",
              a: "Yes. For groups of 15+ adults we often secure group benefits—reduced rates, complimentary or upgraded rooms, private transfers, group meals, and a dedicated guide. Exact savings depend on destination, travel dates and supplier terms. Share your group size, itinerary and dates and we'll prepare a detailed quote with the best available options."
            }
          ]
        }
      ]
    },
    {
      id: 'section2',
      title: 'ABOUT COMPANY',
      description: '',
      questions: [
        {
          q: "Who are Sha tours?",
          a: "Sha tours represent trust, expertise and personalised travel planning. We are committed to delivering seamless, well-crafted journeys through transparent service, strong industry partnerships and deep destination knowledge. Our focus is on understanding each traveller's needs and creating meaningful, memorable experiences. With reliability, professionalism and support at our core, we stand for quality travel solutions designed with care and genuine attention to detail."
        },
        {
          q: "How long has your company been operating?",
          a: "Sha tours have been faithfully serving extremely satisfied travellers within India and Globally since 2010."
        },
        {
          q: "How experienced is your team in handling tours?",
          a: "Our team has decades of experience in Domestic, Inbound and Outbound travel, delivering expertly managed tours for families, groups, and international clients."
        },
        {
          q: "What confirms that Sha tours is a legitimate and trustworthy company?",
          a: "Sha tours is a registered company and an MSME under the Government of India (Udyam Registration: UDYAM-TN-12-0136340). We operate transparently, respond promptly to enquiries, and work with verified local partners to deliver reliable services. Customer satisfaction is our priority — backed by clear booking policies, secure payment options and responsive support to ensure dependable, trustworthy travel arrangements."
        },
        {
          q: "What services does Sha tours provide?",
          a: "We offer end-to-end travel services including itinerary planning, tour packages, flight and hotel bookings, visa support, travel insurance, transportation, and destination guidance. We design Domestic, Inbound and Outbound tours, covering leisure, corporate, luxury, adventure, and custom-made travel."
        },
        {
          q: "Do you offer adventure, luxury, budget-friendly, and group travel options?",
          a: "Yes. Our tours cater to all segments and can be designed based on your style and budget."
        },
        {
          q: "Do you offer tailor-made itineraries or only fixed packages?",
          a: "Every itinerary we create is designed uniquely for you—built entirely around your interests, travel style, and budget. The sample tours on our website are simply ideas to inspire you. Once we have our first discussion, we craft a personalised plan that reflects exactly what you are looking for in your journey."
        },
        {
          q: "Do you plan short getaways as well, or do you only specialize in long vacations?",
          a: "Yes, we plan both short and long vacations. Whether you need a quick weekend getaway or a detailed multi-day itinerary, we design trips that match your time, interests, and budget. Every journey—short or long—is crafted with the same care, expertise, and personalized attention."
        },
        {
          q: "Can Sha tours handle corporate groups, incentive tours, or educational tours?",
          a: "Yes. We manage corporate, MICE, student groups, and special-interest tours with professional coordination."
        },
        {
          q: "How do you customize itineraries for different travellers?",
          a: "We study your interests, travel style, pace, and preferences to craft an itinerary that suits your comfort, budget, and expectations."
        },
        {
          q: "Can I request special arrangements during the trip?",
          a: "Absolutely. We assist with dietary needs, room preferences, accessibility requests, and any additional support required."
        },
        {
          q: "What should I expect from a tour managed by Sha tours?",
          a: "You can expect clear communication, reliable arrangements, quality service, and complete support from start to finish."
        },
        {
          q: "What makes Sha tours the right choice for my travel plans?",
          a: "Sha tours combine decades of expertise, personalised planning and strong industry partnerships to deliver seamless, value-driven travel experiences. We craft tailor-made itineraries, secure exclusive perks and manage every detail—from tickets and accommodation to transfers and support. As a registered and trusted travel company, we offer transparent processes, reliable service and 24/7 assistance. With us, you enjoy stress-free planning, expert guidance and memorable journeys designed around your needs."
        },
        {
          q: "Is Sha tours available for one-time bookings only, or can you support my travel needs on a regular basis?",
          a: "Sha tours supports both one-time trips and long-term travel planning. Many clients trust us for years because we learn their preferences with every journey, making each trip smoother and more personalised. From quick weekend getaways to extended vacations or frequent business travel, we handle it all with care and reliability. You can count on us as your dedicated travel partner for every future journey."
        },
        {
          q: "How transparent are your prices? Are there any hidden charges?",
          a: "Our pricing is clear and upfront. All inclusions and exclusions are shared in advance to ensure complete transparency. You pay solely for the holiday you choose, and only once you are fully satisfied with the final itinerary."
        },
        {
          q: "Does Sha tours earn commission from its travel partners?",
          a: "Yes, Sha tours may receive standard industry commissions from certain travel partners. These amounts vary based on multiple factors, including the volume of business with each supplier, and are a normal part of the travel industry. However, commissions never influence our recommendations. Our focus is always on offering the best options for your needs, preferences, and budget, ensuring your experience remains our top priority."
        },
        {
          q: "How does Sha tours offer such competitive pricing?",
          a: "Sha tours offer highly competitive pricing through strong industry partnerships, direct contracts, and high booking volumes, allowing us to secure better rates and valuable inclusions without compromising quality. As primarily an internet-based company, we keep overheads low and work with hotels on confirmed bookings, paying in advance once your travel is secured. This system builds loyalty with our partners and enables us to consistently negotiate rates lower than many large tour operators, which we pass directly to you, ensuring exceptional value and a seamless, cost-effective travel experience for every trip."
        },
        {
          q: "Is it safe to book a tour through your company?",
          a: "Yes. We work only with verified hotels, trusted partners, and licensed service providers to ensure your safety and comfort."
        },
        {
          q: "How do you ensure the quality of accommodations and services?",
          a: "We collaborate with reputed hotels and experienced vendors, regularly reviewing service standards to maintain consistent quality."
        },
        {
          q: "As an eco-conscious traveller, how does Sha tours promote responsible travel and support sustainable, environmentally friendly practices?",
          a: "At Sha tours, we are committed to promoting responsible and sustainable travel practices. We work closely with local communities, eco-friendly accommodations, and trusted partners who prioritize environmental conservation and ethical operations. Our itineraries are designed to minimize carbon footprints, encourage the use of sustainable transportation, and support local businesses and artisans. We provide travellers with guidance on respecting cultural and natural heritage, reducing waste, and making environmentally conscious choices during their trips. Additionally, our team continually researches and updates practices to align with global sustainability standards. By choosing Sha tours, eco-conscious travellers can enjoy authentic, memorable experiences while knowing their journeys contribute positively to the environment and local communities. Sustainability is an integral part of our planning process, ensuring every trip is both enriching and responsible."
        }
      ]
    },
    {
      id: 'section3',
      title: 'TOUR ENQUIRY',
      description: '',
      questions: [
        {
          q: "How do I submit a tour enquiry with Sha tours?",
          a: "You can share your enquiry through our website form, by email, or by contacting our team directly."
        },
        {
          q: "What information should I provide when making an enquiry?",
          a: "Details like travel dates, destination, number of travellers, preferred budget, and any special requirements help us prepare an accurate proposal."
        },
        {
          q: "How soon will I receive a response to my enquiry?",
          a: "Our team typically responds within 24–48 working hours with initial details or follow-up questions."
        },
        {
          q: "Do I need to have fixed travel dates before submitting an enquiry?",
          a: "Fixed dates are helpful but not mandatory. You may share tentative dates, and we will customise accordingly."
        },
        {
          q: "Can I request multiple destination options in one enquiry?",
          a: "Yes. We can share options for multiple destinations or suggest combinations based on your interests."
        },
        {
          q: "Is there any consultation fee for tour planning or quotations?",
          a: "No. We provide quotations and initial planning assistance at no cost."
        },
        {
          q: "How detailed will my initial itinerary or quote be?",
          a: "Your first quote will include basic itinerary highlights, hotel options, and pricing. Further details are refined during discussions."
        },
        {
          q: "Can I customise the itinerary after receiving the first quote?",
          a: "Absolutely. All itineraries are flexible and can be revised as many times as needed."
        },
        {
          q: "What if I am not sure about my budget yet?",
          a: "You can share a rough range or your preferred hotel category; we will prepare options to suit."
        },
        {
          q: "Do you offer guidance in choosing destinations or planning the trip?",
          a: "Yes. Our team can recommend destinations, routes, and experiences based on your travel style."
        },
        {
          q: "Can I make enquiries for group tours or large family trips?",
          a: "Yes. We handle FIT, family trips, corporate groups, and large group bookings."
        },
        {
          q: "Do you provide enquiries for both Domestic and International travel?",
          a: "Yes. We assist with Domestic, Inbound, and Outbound tour enquiries."
        },
        {
          q: "Will you help me understand visa requirements when I enquire?",
          a: "Yes. We provide basic visa guidance during the planning stage and detailed support once your booking is confirmed."
        },
        {
          q: "Can I request multiple hotel category options in my enquiry?",
          a: "Yes. You may choose from budget, standard, premium, or luxury categories."
        },
        {
          q: "What if I have special requirements like dietary needs or accessibility needs?",
          a: "Please share them during your enquiry. We ensure your itinerary accommodates all special needs."
        },
        {
          q: "Can I enquire for a last-minute trip or urgent travel requirement?",
          a: "Yes. We can assist with urgent travel, subject to availability and destination regulations."
        },
        {
          q: "Is sharing a passport copy required at the enquiry stage for international tours?",
          a: "Not initially. Passport details are required only once your booking is confirmed."
        },
        {
          q: "Do you provide estimates for flights along with tour enquiries?",
          a: "Yes. We can include flight quotes or suggest suitable options upon request."
        },
        {
          q: "How long is the quotation valid once I receive it?",
          a: "Most quotations remain valid for a limited period due to dynamic pricing. The validity will be clearly mentioned in the quote."
        },
        {
          q: "Can I follow up or revise my enquiry after the first quote is provided?",
          a: "Yes. You can request changes at any time, and we will update the proposal accordingly."
        }
      ]
    },
    {
      id: 'section4',
      title: 'BOOKING AND CONFIRMATION',
      description: '',
      questions: [
        {
          q: "How can I book a tour with Sha tours?",
          a: "You can book by contacting us via phone, email, WhatsApp, or by submitting an inquiry on our website. Our team will guide you through every step."
        },
        {
          q: "Do I need to pay a deposit to confirm my booking?",
          a: "Yes. A booking deposit is required to block services and begin confirmations. The amount varies by tour type."
        },
        {
          q: "When will I receive my booking confirmation?",
          a: "Once your deposit and required details are received, we process the booking and share confirmation shortly after."
        },
        {
          q: "What details are required to process my booking?",
          a: "We typically need traveller names, travel dates, destination choices, contact details, and ID proof where required."
        },
        {
          q: "Can I hold a booking without payment?",
          a: "In most cases, services cannot be held without payment, especially during peak seasons. We will inform you if a temporary hold is possible."
        },
        {
          q: "How do I know my booking is confirmed?",
          a: "A confirmation email or voucher will be sent to you once all services are secured."
        },
        {
          q: "Will I receive a confirmation voucher or itinerary after booking?",
          a: "Yes. A detailed confirmation voucher and itinerary will be shared after services are finalized."
        },
        {
          q: "How long does it take to issue a confirmation voucher?",
          a: "It usually takes 24–48 hours after receiving payment and required information. Timings may vary based on availability."
        },
        {
          q: "Can I make changes to my booking after confirmation?",
          a: "Changes are subject to availability and supplier policies. Additional charges may apply."
        },
        {
          q: "What happens if my preferred travel date is not available?",
          a: "We will suggest the nearest available dates or alternative options based on your preference."
        },
        {
          q: "What is the process for confirming hotel or flight availability?",
          a: "We check real-time availability with our suppliers and confirm only after receiving your approval and payment."
        },
        {
          q: "Does availability shown online or quoted initially guarantee confirmation?",
          a: "No. Availability can change quickly. Services are confirmed only after payment and written acknowledgment from our side."
        },
        {
          q: "What should I do if I don't receive my confirmation email?",
          a: "Please check your spam folder or contact us directly. We will resend the confirmation immediately."
        },
        {
          q: "Are last-minute bookings accepted?",
          a: "Yes, we assist with last-minute bookings based on availability. Quick payment and details are required."
        },
        {
          q: "Can I book on behalf of someone else?",
          a: "Yes. Please provide accurate traveller details and ensure they meet all travel requirements."
        },
        {
          q: "Is my booking guaranteed once payment is made?",
          a: "Your booking is guaranteed only after written confirmation or receipt of vouchers from our team."
        },
        {
          q: "Do you provide provisional itineraries before confirmation?",
          a: "Yes. We share draft itineraries to help you plan before finalizing and confirming services."
        },
        {
          q: "How are peak-season bookings handled?",
          a: "Peak seasons require early booking and higher deposits due to limited availability. We will guide you accordingly."
        },
        {
          q: "Will I be informed if there is a waitlist for any service?",
          a: "Yes. We will notify you immediately and suggest alternatives when a waitlist applies."
        },
        {
          q: "How soon should I book to secure the best rates and availability?",
          a: "Booking at least 30–90 days in advance is recommended, especially for holidays, festivals, and international travel."
        }
      ]
    },
    {
      id: 'section5',
      title: 'TRIP DOCUMENTS',
      description: '',
      subSections: [
        {

          questions: [
            {
              q: "What important documents do I need to get in order before my trip?",
              a: "Travel Tickets, Passport, VISA, Travel Insurance, Inoculation Certificates, Proof of Accommodation, etc."
            },
            {
              q: "Do I need to carry any ID proof while traveling?",
              a: "For Domestic (Within India), all tourists traveling by air/rail must carry photo identification proof in the form of driving license, election ID card, PAN card, Aadhaar card, passport and for students their school/college ID card. For International (Beyond India), all tourists should have a Valid Passport, VISA, Travel Insurance and Inoculation Certificates."
            }
          ]
        },
        {
          title: 'Travel Tickets (Flight)',
          questions: [
            {
              q: "Do you provide both domestic and international air ticket bookings?",
              a: "Yes, we handle both domestic and international air ticketing for leisure, business, and group travellers across all major airlines."
            },
            {
              q: "Can you help me find the best airfare for my travel dates?",
              a: "Absolutely. We compare multiple airlines and fare options to offer you the most convenient and cost-effective options for your journey."
            },
            {
              q: "Can I request a specific airline or flight timing while booking?",
              a: "Of course. You can specify your preferred airline, flight timing, or routing, and we will tailor your booking accordingly."
            },
            {
              q: "Do you offer special or discounted fares for group travel?",
              a: "Yes. We provide competitive group fares for families, corporate teams, and special interest groups, based on airline availability."
            },
            {
              q: "How far in advance should I book my flight to get the best fares?",
              a: "We recommend booking 30–45 days in advance for the best fares, though this varies by airline, route, and season."
            },
            {
              q: "Can I hold a booking without payment?",
              a: "Some airlines allow temporary booking holds for a few hours or days. We can check availability and hold options for your specific route."
            },
            {
              q: "What information do you need to issue a flight ticket?",
              a: "We require passenger names as per passport or ID, travel dates, destination, and contact details to process your ticket."
            },
            {
              q: "Why am I asked to give my passport name, gender, and date of birth when booking air?",
              a: "If the name on your ticket doesn't exactly match your passport or government ID, boarding may be denied. Ensure all details are correct at the time of booking, as any spelling or name changes may incur fees, penalties, or cancellations."
            },
            {
              q: "What should I do if there is name or spelling mistake on my ticket?",
              a: "Contact us immediately. Minor corrections may be allowed, but major changes may require re-issuance as per airline policy."
            },
            {
              q: "How do I make changes or cancellations after my ticket is issued?",
              a: "Just contact us. We will check the airline's rules, process the changes, and guide you through the rebooking or refund process."
            },
            {
              q: "Are there any charges for rebooking or cancelling a flight?",
              a: "Yes, most airlines may apply modification or cancellation fees depending on the fare type. We will inform you of all charges before proceeding."
            },
            {
              q: "Will I get a refund if I cancel my flight?",
              a: "Refunds depend on the ticket's fare conditions and airline policy. We will assist you in processing eligible refunds promptly."
            },
            {
              q: "Do you assist with online check-in, seat selection, add extra baggage or meal preferences?",
              a: "Yes, we can help you with web check-in, seat reservations, add extra baggage, meal requests, and special assistance if required."
            },
            {
              q: "How do I know if my ticket has been confirmed?",
              a: "You will receive a confirmation email/message with your e-ticket number and airline PNR once your booking is successfully issued."
            },
            {
              q: "Will I receive an e-ticket, or do you provide paper tickets?",
              a: "All our tickets are issued electronically (e-tickets) and sent to your registered email address for convenience."
            },
            {
              q: "Can I earn frequent flyer miles through tickets booked with you?",
              a: "Yes, simply provide your frequent flyer number at the time of booking, and we will include it in your reservation to ensure you earn miles on eligible flights."
            },
            {
              q: "Who do I contact in case of flight delays, rescheduling, or cancellations by the airline?",
              a: "You can contact us or the airline directly for real-time updates. We will assist you in rebooking or alternate arrangements."
            }
          ]
        },
        {
          title: 'Travel Tickets (Train)',
          questions: [
            {
              q: "Do you handle train ticket bookings across India?",
              a: "Yes, we provide rail ticket booking services for major routes and luxury trains across India through authorized booking channels."
            },
            {
              q: "Can you book both regular and luxury train journeys?",
              a: "Absolutely. We handle both standard Indian Railways bookings and luxury trains like Palace on Wheels, Maharajas' Express, Deccan Odyssey and Golden Chariot, etc."
            },
            {
              q: "What details are required to book a train ticket?",
              a: "We need passenger names (as per ID proof), travel date, preferred class, and destination details."
            },
            {
              q: "Can I choose my preferred seat or berth type?",
              a: "Yes, we can request specific seat or berth preferences (upper, lower, side, etc.) based on availability."
            },
            {
              q: "Do you provide train schedules and fare details?",
              a: "Yes, we share updated train timings, routes, and fare options to help you plan your travel efficiently."
            },
            {
              q: "How do I modify or cancel a rail ticket?",
              a: "You can contact us directly, and we will assist with rescheduling or cancellation as per railway rules and refund policies."
            },
            {
              q: "Can I check PNR status or live train updates through you?",
              a: "Yes, we can help you track your PNR status and provide real-time updates on your train's schedule and platform details."
            },
            {
              q: "Do you arrange connecting transfers along with rail travel?",
              a: "Yes, we can organize pick-up and drop-off transfers from railway stations to hotels or other destinations."
            },
            {
              q: "Do you assist international tourists with Indian train bookings?",
              a: "Definitely. We help international travellers with Indian rail reservations, including advice on routes, classes, and travel comfort."
            }
          ]
        },
        {
          title: 'Passport',
          questions: [
            {
              q: "Why is a passport important for international travel?",
              a: "A passport is the official proof of your nationality and identity, required for entering or leaving any foreign country."
            },
            {
              q: "Is a passport mandatory for travelling abroad?",
              a: "Yes. A valid passport is essential for all international travel, as it's recognized globally as your primary travel document."
            },
            {
              q: "Can I travel to any foreign country without a passport?",
              a: "No. A passport is mandatory for travel outside India, except for specific visa-free agreements with certain countries (if any)."
            },
            {
              q: "What information does a passport contain?",
              a: "It includes your personal details, photograph, nationality, and unique passport number—used for identity verification worldwide."
            },
            {
              q: "How does a passport serve as proof of identity and nationality?",
              a: "It is issued by the Government of India and certifies you as a legal citizen, recognized internationally by immigration authorities."
            },
            {
              q: "Do I need a passport for travel within India?",
              a: "No. Domestic travel within India requires only a valid photo ID, not a passport."
            },
            {
              q: "Can I travel within India without a passport?",
              a: "Yes. Domestic travel only requires a valid photo ID such as Aadhaar, PAN, or driver's license."
            },
            {
              q: "What happens if I lose my passport while travelling overseas?",
              a: "You should immediately report it to the nearest Indian Embassy or Consulate, which will assist with a replacement or emergency travel document."
            },
            {
              q: "Why should I keep my passport valid even if I am not planning to travel soon?",
              a: "Having a valid passport allows you to travel anytime and simplifies urgent visa or business travel requirements."
            },
            {
              q: "How early should I apply for a passport before an international trip?",
              a: "It is best to apply at least 2–3 months in advance to allow sufficient time for processing and verification."
            },
            {
              q: "Can I use a passport as a valid ID proof in India?",
              a: "Yes. A passport is a government-issued document accepted as valid identity and address proof across India."
            },
            {
              q: "Is a passport required for obtaining a visa?",
              a: "Yes. You must have a valid passport to apply for any type of visa for international travel."
            },
            {
              q: "What is the difference between a passport and a visa?",
              a: "A passport identifies you as a citizen of your country, while a visa grants you permission to enter a foreign nation."
            },
            {
              q: "How long is a passport valid for?",
              a: "Generally, Indian passports are valid for 10 years for adults and 5 years for minors."
            },
            {
              q: "Why do some countries require at least six months of passport validity?",
              a: "Many countries mandate six months' validity to ensure travellers don't face issues during extended stays or emergencies."
            },
            {
              q: "What are the consequences of travelling with an expired passport?",
              a: "You won't be allowed to board international flights or enter foreign countries with an expired passport."
            },
            {
              q: "Can children and infants also get a passport for travel?",
              a: "Yes. Every individual must hold a valid passport for international travel. This includes travellers under the age of 18."
            },
            {
              q: "How does having a passport make future travel easier?",
              a: "It simplifies visa applications and allows you to plan spontaneous or last-minute international trips without delay."
            },
            {
              q: "Is it necessary to carry a physical passport during international travel?",
              a: "Yes. You must carry the original passport, as digital or photocopies are not accepted at immigration checkpoints."
            },
            {
              q: "Can digital or scanned copies of passports be used at airports?",
              a: "No. Only the physical, original passport is accepted for travel verification and immigration clearance."
            },
            {
              q: "Why should travellers safeguard their passports during the trip?",
              a: "Losing a passport abroad can cause serious delays; it is vital to always keep it safe and secure."
            },
            {
              q: "NOTE",
              a: "Always keep a photocopy of your passport in a safe place, separate from the original. It is also wise to store a digital copy securely in your email or cloud storage so you can access it easily in case of an emergency."
            }
          ]
        },
        {
          title: 'VISA',
          questions: [
            {
              q: "What is a visa and why is it required for international travel?",
              a: "VISA is the short form for Visitors Intending to Stay Abroad. It is an official permit issued by a country's embassy or consulate, allowing travellers to enter, stay, or transit through that country legally."
            },
            {
              q: "Do all countries require a visa for entry?",
              a: "No, some countries offer visa-free access or visa-on-arrival entry depending on your nationality and purpose of travel."
            },
            {
              q: "What's the difference between a passport and a visa?",
              a: "A passport is your identification document for international travel, while a visa is a country's permission for you to enter or stay there."
            },
            {
              q: "Can I travel abroad without a visa?",
              a: "You can only travel without a visa to countries that have visa-free access or e-Visa agreements with your country."
            },
            {
              q: "What are the common types of visas issued by countries?",
              a: "Tourist, business, student, work, and transit visas are the most common categories."
            },
            {
              q: "How do I know if I need a visa for a specific country?",
              a: "You can check visa requirements on the destination's embassy website or contact us."
            },
            {
              q: "What documents are usually required to apply for a visa?",
              a: "Usually, you will need a valid passport, photos, confirmed tickets, hotel booking, financial proof, and a completed application form. We will provide full visa requirement details during your tour planning."
            },
            {
              q: "What does a visa approval or rejection depend on?",
              a: "Visa approval depends on factors like eligibility, correct documentation, financial stability, and travel purpose. The final decision rests entirely with the respective Consulate or Embassy."
            },
            {
              q: "How early should I apply for a visa before travelling?",
              a: "It is advisable to start your visa application early, as processing times can sometimes take longer than expected."
            },
            {
              q: "Why should I not rely on last-minute visa applications?",
              a: "Processing times vary; last-minute applications risk delays or rejection that could affect your travel plans."
            },
            {
              q: "What is the difference between e-Visa, Visa on Arrival, and stamped visa?",
              a: "An e-Visa is applied online, Visa on Arrival is issued at the airport, and a stamped visa is pre-approved by an embassy."
            },
            {
              q: "Can I travel to multiple countries with a single visa?",
              a: "Some visas, like the Schengen Visa, allow travel across multiple countries; others are valid only for one."
            },
            {
              q: "Is a visa required for cruise vacations or transit through a country?",
              a: "Yes, depending on the ports of call or stopover countries, a visa may still be needed."
            },
            {
              q: "What happens if I overstay my visa validity?",
              a: "Overstaying can lead to fines, deportation, or future visa restrictions."
            },
            {
              q: "Can I extend my visa once I am abroad?",
              a: "Some countries allow extensions; you must apply before your visa expires."
            },
            {
              q: "Why do visa rules differ from country to country?",
              a: "Visa policies are set by each nation based on diplomatic relations, security, and immigration laws."
            },
            {
              q: "Can you assist with my visa application?",
              a: "Yes. We assist with documentation, form filling, appointments, and updated visa guidelines. However, visa approval is beyond our control and solely at the discretion of the respective Embassy or Consulate."
            },
            {
              q: "How important is accuracy in visa documentation?",
              a: "Very important — incorrect or incomplete information can lead to rejection or delays."
            },
            {
              q: "What should I do if my visa is refused?",
              a: "You can reapply after correcting the issues or provide additional supporting documents if requested."
            },
            {
              q: "Do children also need a visa for international travel?",
              a: "Yes, every traveller, including minors, must hold a valid visa unless exempted by specific policies."
            }
          ]
        },
        {
          title: 'Travel Insurance',
          questions: [
            {
              q: "What is travel insurance, and why is it important?",
              a: "Travel insurance protects you from unexpected expenses such as medical emergencies, trip cancellations, or lost baggage during travel. It ensures financial safety and peace of mind throughout your journey."
            },
            {
              q: "Is travel insurance mandatory for all international trips?",
              a: "Some countries require travel insurance for visa approval or entry. Even when not mandatory, it's highly recommended for all travellers."
            },
            {
              q: "What does a standard travel insurance policy usually cover?",
              a: "Most plans cover medical emergencies, trip cancellations, flight delays, lost baggage, and personal liability."
            },
            {
              q: "Does travel insurance cover medical emergencies abroad?",
              a: "Yes, most policies include emergency medical treatment, hospitalization, and evacuation if needed."
            },
            {
              q: "Can I get coverage for trip cancellations or interruptions?",
              a: "Yes. If your trip is cancelled or interrupted due to illness, accidents, or unforeseen events, insurance can reimburse your non-refundable costs."
            },
            {
              q: "Will my travel insurance cover lost or delayed baggage?",
              a: "Yes. Travel insurance compensates for lost, delayed, or stolen baggage and essential items."
            },
            {
              q: "When should I purchase travel insurance — before or after booking my trip?",
              a: "It's best to purchase travel insurance right after confirming your bookings to enjoy full coverage benefits."
            },
            {
              q: "Does travel insurance cover COVID-19 or other health-related emergencies?",
              a: "Many insurers now offer COVID-19 coverage. Confirm the policy terms before purchase."
            },
            {
              q: "Can I extend my travel insurance if my trip is extended?",
              a: "Yes, most policies can be extended before your current coverage expires."
            },
            {
              q: "Does travel insurance cover adventure or sports activities?",
              a: "Some plans cover limited adventure activities. Always check the inclusions before purchase."
            },
            {
              q: "How do I make a claim if something goes wrong during my trip?",
              a: "Contact your insurance provider's helpline immediately and follow the claim submission process as per policy guidelines."
            },
            {
              q: "Can I buy travel insurance for domestic trips within India?",
              a: "Yes. Domestic travel insurance is available for coverage against accidents, cancellations, or lost baggage."
            },
            {
              q: "What documents are required to buy travel insurance?",
              a: "A valid passport, travel dates, destination details, and traveller information are generally required."
            },
            {
              q: "Are pre-existing medical conditions covered under travel insurance?",
              a: "Some insurers offer limited coverage for stable pre-existing conditions. Always verify before buying."
            },
            {
              q: "How much does travel insurance usually cost?",
              a: "It depends on trip duration, destination, traveller's age, and coverage type. Most plans are affordably priced."
            },
            {
              q: "Does travel insurance provide 24x7 assistance while traveling?",
              a: "Yes. Most companies offer round-the-clock global support for emergencies."
            },
            {
              q: "Can I buy travel insurance for a group or family trip?",
              a: "Yes, family and group travel policies are available and often more economical."
            },
            {
              q: "What is not covered under travel insurance?",
              a: "Common exclusions include self-inflicted injuries, illegal activities, and travel without valid documents."
            },
            {
              q: "How soon will I get reimbursed after filing a claim?",
              a: "Processing time varies, but valid claims are usually settled within a few weeks after submission."
            },
            {
              q: "Why should I buy travel insurance through a tour operator instead of online?",
              a: "A tour operator ensures you get the right policy, guides you through claims, and offers personal assistance throughout your journey."
            }
          ]
        },
        {
          title: 'Inoculation Certificate',
          questions: [
            {
              q: "What is an inoculation or vaccination certificate, and why is it needed for travel?",
              a: "It's an official record confirming you've received required vaccinations. Some countries demand it to prevent the spread of infectious diseases."
            },
            {
              q: "Are vaccination certificates mandatory for all international travellers?",
              a: "Not for all destinations, but certain countries require specific vaccinations for entry."
            },
            {
              q: "Which vaccinations are commonly required for international travel?",
              a: "Yellow Fever, Polio, Typhoid, Hepatitis A & B, and Meningitis are among the most common."
            },
            {
              q: "Do I need a Yellow Fever vaccination certificate for certain countries?",
              a: "Yes, it's mandatory for travellers visiting or transiting through Yellow Fever–risk countries."
            },
            {
              q: "How do I know which vaccines are required for my destination?",
              a: "We will guide you with destination-specific requirements during your tour planning."
            },
            {
              q: "Where can I get the required travel vaccinations and certificates?",
              a: "Authorized government hospitals and approved medical centres provide them."
            },
            {
              q: "How long before my trip should I get vaccinated?",
              a: "Ideally, 4–6 weeks before departure to allow immunity to build."
            },
            {
              q: "Is the COVID-19 vaccination certificate still required for travel?",
              a: "Some countries still ask for it; requirements vary by destination."
            },
            {
              q: "What happens if I don't carry a required vaccination certificate?",
              a: "You may be denied boarding or entry or be quarantined at the port of arrival."
            },
            {
              q: "Do children also need inoculation certificates for travel?",
              a: "Yes, if the destination mandates it for all travellers, regardless of age."
            },
            {
              q: "How long is a Yellow Fever certificate valid for?",
              a: "It's valid for life from the date of vaccination."
            },
            {
              q: "Are there exemptions for travellers with medical conditions?",
              a: "Yes, with an official medical waiver certified by a registered doctor."
            },
            {
              q: "Do I need to carry the original certificate, or is a digital copy accepted?",
              a: "Carry the original; digital copies may not be accepted at all checkpoints."
            },
            {
              q: "Can vaccinations be done at the airport before departure?",
              a: "Some international airports offer limited vaccination facilities, but advance vaccination is strongly advised."
            },
            {
              q: "How can I update or replace a lost vaccination certificate?",
              a: "Contact the issuing health centre or local health department for reissuance."
            },
            {
              q: "Do domestic travellers within India need vaccination certificates?",
              a: "No, they are not required for travel within India."
            },
            {
              q: "Are there special vaccination rules for pilgrimage or group tours?",
              a: "Yes, destinations like Saudi Arabia (for Hajj / Umrah) have specific vaccination requirements."
            },
            {
              q: "How early should I consult my doctor before international travel?",
              a: "Consult at least 6 weeks before travel for vaccination advice and scheduling."
            },
            {
              q: "Can you assist me with vaccination requirements?",
              a: "Yes, we will guide you with up-to-date health regulations and necessary certificates."
            },
            {
              q: "Are all vaccines covered under travel insurance or health insurance?",
              a: "Not always. Coverage depends on your insurance policy terms and provider."
            }
          ]
        }
      ]
    },
    {
      id: 'section6',
      title: 'PAYMENTS',
      description: '',
      questions: [
        {
          q: "What payment methods do you accept?",
          a: "We accept bank transfers, UPI, and select online payment gateways."
        },
        {
          q: "Do I need to pay an advance to confirm my booking?",
          a: "Yes, an advance payment is required to secure your reservation."
        },
        {
          q: "How much is the advance payment required?",
          a: "The advance amount varies by package and will be shared during the confirmation process."
        },
        {
          q: "When is the full payment due?",
          a: "Full payment is typically required 7–15 days before the travel date, depending on the service provider."
        },
        {
          q: "Can I pay in instalments?",
          a: "Yes, instalments may be allowed based on the package and travel dates."
        },
        {
          q: "Do you accept international payments from overseas clients?",
          a: "Yes, we accept international remittances through approved global payment channels."
        },
        {
          q: "Is my booking confirmed once I make the advance payment?",
          a: "Your booking is confirmed after we receive the advance and share a written confirmation."
        },
        {
          q: "Will I receive a payment receipt or invoice?",
          a: "Yes, a detailed invoice or receipt will be issued for every payment made."
        },
        {
          q: "Do the prices include all taxes?",
          a: "Taxes are mentioned clearly during quotation. If excluded, they will be specified separately."
        },
        {
          q: "Are there any additional service charges or hidden fees?",
          a: "No hidden charges. Any additional fees, if applicable, will be disclosed upfront."
        },
        {
          q: "Do you accept payments through UPI or bank transfer?",
          a: "Yes, UPI and direct bank transfers are both accepted."
        },
        {
          q: "Can someone else make the payment on my behalf?",
          a: "Yes, payments can be made by a third party as long as the details are shared with us."
        },
        {
          q: "What currency do you accept for international bookings?",
          a: "International payments can be made in major global currencies approved by our payment partners."
        },
        {
          q: "Are payments refundable in case of cancellation?",
          a: "Refunds depend on our cancellation policy and supplier terms. Details will be shared at booking."
        },
        {
          q: "How long does it take to process a refund?",
          a: "Refund timelines vary between 7–21 working days, depending on service providers."
        },
        {
          q: "Do you offer secure payment options?",
          a: "Yes, all payments are processed through secure, verified payment channels."
        },
        {
          q: "What happens if I miss a payment deadline?",
          a: "Missing a deadline may result in booking cancellation or revised pricing based on availability."
        },
        {
          q: "Can I change or update my payment method later?",
          a: "Yes, you may update your payment method before the final settlement."
        },
        {
          q: "Will the package price change if I delay the payment?",
          a: "Prices may change due to fluctuation in supplier costs or availability if payment is delayed."
        }
      ]
    },
    {
      id: 'section7',
      title: 'CANCELLATION & REFUND',
      description: '',
      questions: [
        {
          q: "What is your cancellation policy?",
          a: "Our cancellation terms vary based on the service provider, booking type, and travel date. Full details will be shared at the time of confirmation."
        },
        {
          q: "How do I request a cancellation?",
          a: "You can email or call us with your booking details. We will process the request and update you on applicable charges."
        },
        {
          q: "How much cancellation fee will be charged?",
          a: "Fees depend on airline, hotel, and service provider rules. We will provide an exact breakdown once the cancellation request is submitted."
        },
        {
          q: "Are cancellations allowed after the booking is confirmed?",
          a: "Yes, but they are subject to the terms of each service provider and may involve charges."
        },
        {
          q: "Can I cancel only specific services within my package?",
          a: "In most cases, yes. However, some bundled services may follow a combined cancellation policy."
        },
        {
          q: "What if the hotel or airline has a different cancellation policy?",
          a: "Their policy will take precedence, and refunds will be processed as per their rules."
        },
        {
          q: "Will I get a refund if I cancel due to a medical emergency?",
          a: "Refund eligibility depends on provider policies. Supporting documents may be required."
        },
        {
          q: "How long does it take to receive my refund?",
          a: "Refunds usually take 7–21 working days, depending on the provider's processing time."
        },
        {
          q: "Is the advance payment refundable?",
          a: "Advance payments are refundable only if permitted by the respective service provider."
        },
        {
          q: "Are refunds processed back to the same payment method?",
          a: "Yes, refunds are returned to the original mode of payment unless otherwise required."
        },
        {
          q: "What happens if I cancel close to the travel date?",
          a: "Higher cancellation charges may apply, and some bookings may become non-refundable."
        },
        {
          q: "Can I modify my travel dates instead of cancelling?",
          a: "Modifications are possible but are subject to availability and any applicable amendment fees."
        },
        {
          q: "Will I get a full refund if the operator cancels the tour?",
          a: "If we cancel the tour, you will receive a full refund or the option to rebook."
        },
        {
          q: "What if a service provider cancels my booking?",
          a: "Refunds or alternative arrangements will be provided as per the provider's policy."
        },
        {
          q: "Are no-show bookings eligible for refunds?",
          a: "No-shows are generally non-refundable as per airline and hotel rules."
        },
        {
          q: "What happens if my visa gets rejected — do I get a refund?",
          a: "Refunds depend on the cancellation terms of each service provider. Visa fees are non-refundable."
        },
        {
          q: "Are partially used services refundable?",
          a: "Partially used services are typically non-refundable."
        },
        {
          q: "Do I need to submit any documents for a refund claim?",
          a: "Some providers may require documentation, especially for medical or emergency cancellations."
        },
        {
          q: "Are group bookings subject to different cancellation rules?",
          a: "Yes, group bookings usually follow stricter terms with higher cancellation fees."
        },
        {
          q: "Can I transfer my booking to someone else instead of cancelling?",
          a: "This depends on the airline or provider's rules. Some may allow name changes with a fee."
        }
      ]
    },
    {
      id: 'section8',
      title: 'ON TOUR',
      description: '',
      questions: [
        {
          q: "What should I expect on the first day of my personalised tour?",
          a: "You will be greeted by our representative/driver, briefed on the plan for the day, and assisted with your check-in or transfers as per your itinerary."
        },
        {
          q: "How will I locate my assigned driver or representative upon arrival?",
          a: "Your driver will meet you at the designated arrival point with a placard and will stay in contact using the details shared in advance."
        },
        {
          q: "When does the daily sightseeing usually begin on a private tour?",
          a: "Most sightseeing begins in the morning, but the timing can be adjusted to suit your comfort and the destination's operating hours."
        },
        {
          q: "Will I receive a complete and detailed itinerary before travel?",
          a: "Yes, a confirmed day-by-day itinerary will be shared before departure for your clarity and planning."
        },
        {
          q: "Are meals included, and can dietary preferences be arranged?",
          a: "Meals are included as per your package, and we can coordinate dietary requirements with hotels and restaurants in advance."
        },
        {
          q: "What type of vehicle and transport arrangements will be provided?",
          a: "You will travel in a private, comfortable air-conditioned vehicle suitable for your group size and itinerary."
        },
        {
          q: "Are attraction entrance tickets included in my customised package?",
          a: "Tickets are included only where mentioned in your package; additional entries can be arranged on request."
        },
        {
          q: "Is there a luggage limit during transfers or internal travel?",
          a: "Standard luggage allowances apply based on the vehicle or airline used. We will advise you in advance if restrictions apply."
        },
        {
          q: "Can the airline arrange a wheelchair for me at the airport?",
          a: "Yes, airlines provide wheelchair assistance from check-in to boarding and arrival. We will request this service for you when booking your ticket."
        },
        {
          q: "Will a professional guide accompany me for specific sightseeing experiences?",
          a: "Guides are arranged at key locations where expert commentary enhances the experience; this will be indicated in your itinerary."
        },
        {
          q: "How will coordination be handled throughout the day's sightseeing?",
          a: "Your driver or local guide will brief you on meeting points, timings, and any specific instructions to ensure smooth coordination."
        },
        {
          q: "How much personal free time can I expect each day?",
          a: "Every FIT itinerary includes flexible free time, and additional leisure time can be added based on your preference."
        },
        {
          q: "Can I extend my holiday while travelling?",
          a: "Yes, extensions are possible based on availability. Simply inform us in advance so we can adjust your arrangements smoothly."
        },
        {
          q: "Can I spend more time at a location and join the driver later?",
          a: "This is possible in many cases, provided it fits the day's schedule and your safety is ensured."
        },
        {
          q: "Can the day's plan be adjusted once the tour has already started?",
          a: "Minor adjustments are possible, subject to feasibility, time, and operational conditions."
        },
        {
          q: "What happens if I report late for a scheduled activity or pickup?",
          a: "We will try to adjust the plan where possible, but delays may reduce the time available for the activity."
        },
        {
          q: "Will there be rest and refreshment breaks during long travel days?",
          a: "Yes, your driver will plan regular breaks for comfort, refreshments, and photography stops."
        },
        {
          q: "Can I skip an activity and relax if I feel tired?",
          a: "Yes, you may opt out of any non-essential activity and enjoy some rest time."
        },
        {
          q: "Will any parts of the tour involve moderate walking or physical activity?",
          a: "Some attractions may involve walking or steps. We will inform you in advance so you can prepare comfortably. We guide you in choosing a tour that suits your comfort."
        },
        {
          q: "Can I use my wheelchair during the tour?",
          a: "Yes, you can bring a wheelchair. Please inform us in advance so we can arrange suitable vehicles and accessible facilities wherever possible."
        },
        {
          q: "Will the attractions be accessible if I'm using a wheelchair?",
          a: "You may take a wheelchair, and we will plan your itinerary with accessible routes and attractions. Some locations may have limitations, but we will guide you on the best options."
        },
        {
          q: "Can I use my mobile phone and access the internet during the trip?",
          a: "Yes, mobile networks and internet are widely available. Hotels usually provide Wi-Fi access."
        },
        {
          q: "Are there specific rules or guidelines should I follow while visiting cultural or religious sites?",
          a: "Yes, certain sites may require modest clothing, silence, or restricted photography. Your driver / guide will brief you in advance."
        },
        {
          q: "Is shopping included, and is participation optional?",
          a: "Shopping is optional and not compulsory. We only suggest reliable outlets. Visits can be included or skipped based on your preference."
        },
        {
          q: "Are tips or gratuities included in my package, or should I pay them separately?",
          a: "Tips or Gratuities are generally not included unless specified. You may tip based on your discretion."
        },
        {
          q: "How are unexpected weather-related disruptions managed?",
          a: "We follow local advisories and will adjust the itinerary with safe and suitable alternative arrangements when required."
        },
        {
          q: "What steps are taken if a service provider makes a sudden change?",
          a: "We will coordinate the best available alternatives and keep you informed to ensure minimal disruption."
        },
        {
          q: "What general safety practices should I follow while travelling?",
          a: "Follow local guidelines, take care of personal belongings, and stay in touch with your driver or representative when exploring."
        },
        {
          q: "How are misplaced or lost items handled during the trip?",
          a: "Inform us immediately so we can coordinate with the concerned service providers to help locate the item."
        },
        {
          q: "What should I do if I need assistance or face any issue during the tour?",
          a: "Contact our support team immediately so we can resolve it promptly."
        },
        {
          q: "Will I have access to a dedicated support contact at all times?",
          a: "Yes, you will receive round-the-clock assistance throughout your journey."
        },
        {
          q: "Whom do I contact for immediate support in an emergency?",
          a: "You will receive a dedicated 24/7 emergency contact number prior to departure."
        },
        {
          q: "Will children or elderly travellers receive additional assistance?",
          a: "Yes, we provide added care, slower pacing, and suitable arrangements to ensure their comfort and safety."
        },
        {
          q: "What should I do if I feel unwell at any point during the tour?",
          a: "Inform your driver or representative immediately so we can arrange assistance or medical support if needed."
        },
        {
          q: "Can I buy medicines while travelling abroad?",
          a: "Basic medicines are available in most destinations, but we recommend carrying your essential prescriptions. If needed, we can guide you to a nearby pharmacy or medical facility."
        }
      ]
    },
    {
      id: 'section9',
      title: 'POST TOUR',
      description: '',
      questions: [
        {
          q: "Will someone from your team contact me after the tour?",
          a: "Yes. Our team may reach out for feedback and to ensure your overall experience was smooth and satisfying."
        },
        {
          q: "Do you collect reviews or testimonials from travellers?",
          a: "Yes. We welcome your reviews and testimonials, as they help us understand your experience, refine our services and guide future travellers."
        },
        {
          q: "How can I share my feedback after the tour?",
          a: "You may share your feedback through our post-tour survey, email, feedback channels or by contacting our team directly."
        },
        {
          q: "Can I share photos from my trip with your team?",
          a: "Yes. We welcome your photos and memories and would be happy to receive them."
        },
        {
          q: "Do you feature guest photos or experiences on your website or social media?",
          a: "With your consent, selected guest photos or experiences may be featured on our platforms."
        },
        {
          q: "Can I request the same itinerary or modify it for a future trip?",
          a: "Absolutely. We can recreate or customise the itinerary based on your next travel plan."
        },
        {
          q: "Do repeat customers receive any special offers or benefits?",
          a: "Yes. Repeat travellers may receive exclusive offers, upgrades, or early access to seasonal promotions."
        },
        {
          q: "How soon can I start planning my next tour with you?",
          a: "You can begin planning anytime. Our team is ready to assist you whenever you're ready for your next journey."
        },
        {
          q: "Will I receive a final invoice or statement after the tour?",
          a: "Yes. A final invoice or statement will be shared upon completion of the trip."
        },
        {
          q: "Can I request duplicate bills, vouchers, or receipts later?",
          a: "Certainly. Duplicate documents can be issued upon request."
        },
        {
          q: "When will I receive any pending refunds (if applicable)?",
          a: "Refunds are processed as per our policy, and timelines depend on hotel, airline, or vendor processing."
        },
        {
          q: "How do I check the status of my refund or reimbursement?",
          a: "You can contact our team, and we will update you on the refund status."
        },
        {
          q: "What should I do if I face an issue after returning from the tour?",
          a: "Please contact us immediately. We will review the concern and assist you with the necessary follow-up."
        },
        {
          q: "Can I get assistance if I lost something during the trip and realised it after returning?",
          a: "Yes. We can coordinate with hotels, transport partners, and local teams to check if the item can be located."
        },
        {
          q: "How can I get a copy of my travel insurance claim documents?",
          a: "You may request the documents from us, and we will coordinate with the insurance partner."
        },
        {
          q: "Can I contact you for guidance on insurance or documentation even after the tour has ended?",
          a: "Yes. We remain available for assistance with insurance claims or travel documentation."
        },
        {
          q: "What should I do if I develop a medical issue related to the trip after returning?",
          a: "Please seek medical assistance immediately and contact us if you require support with reports or insurance guidance."
        },
        {
          q: "Whom should I contact for post-tour support?",
          a: "You may reach our support team through email, phone, or your designated tour coordinator."
        }
      ]
    }
  ];


  // Calculate total number of questions for the button text
  const totalQuestions = faqSections.reduce((total, section) => {
    if (section.subSections) {
      return total + section.subSections.reduce((subTotal, subSection) => subTotal + subSection.questions.length, 0);
    }
    return total + (section.questions ? section.questions.length : 0);
  }, 0);

  // Function to generate unique accordion ID for each question
  const generateAccordionId = (sectionId, subIndex, faqIndex) => {
    if (subIndex !== undefined) {
      return `${sectionId}-sub${subIndex}-faq${faqIndex}`;
    }
    return `${sectionId}-faq${faqIndex}`;
  };

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <section 
        className="hero-section text-white text-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${assets.faq})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
        }}
      >
        <div className="container py-5" data-aos="fade-up">
          <h1 className="display-3 fw-bold mb-4">Got Questions?</h1>
          <h5 className="lead mb-4">
            We've got answers! Everything you need to know before booking your dream trip
          </h5>
        </div>
      </section>

      {/* FAQ Sections */}
      <Container className="my-5 py-5">
        <Row className="justify-content-center">
          <Col lg="8" className="text-justify mb-4">
            <h2 className="fw-bold mb-3" style={{ color: '#040695' , textAlign:'center'}}>Frequently Asked Questions</h2>
            <p style={{textAlign:'justify'}} >Making the right choices for your customized tour involves various considerations, from selecting a destination to completing the booking process. You may have questions about your tour details like itinerary, accommodation, meals, duration, transportation, costing and other aspects. Our Frequently Asked Questions section is here to assist you in resolving all your queries and ensuring a seamless travel experience. Let us answer some frequently asked questions about working with a concierge-style tour operator, like Sha tours.</p>
           
          </Col>
          <Col lg="10">
            {faqSections.map((section, sectionIndex) => (
              <div key={section.id} className="mb-5">
                {/* Section Header - Clickable Title */}
                <div 
                  className="section-header mb-4 p-4 rounded-4 cursor-pointer"
                  style={{
                    backgroundColor: openSection === section.id ? '#040695' : '#f8f9fa',
                    color: openSection === section.id ? 'white' : '#040695',
                    border: '2px solid #040695',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => toggleSection(section.id)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 fw-bold" >
                      {section.title}
                    </h4>
                    <span style={{ fontSize: '1.5rem' }}>
                      {openSection === section.id ? <FiArrowUp /> : <FiArrowDown />}
                    </span>
                  </div>
                  
                  {openSection === section.id && section.description && (
                    <div 
                      className="mt-3 pt-3"
                      style={{
                        borderTop: '1px solid rgba(255,255,255,0.3)',
                        fontSize: '1.1rem',
                        lineHeight: '1.6'
                      }}
                    >
                      {section.description}
                    </div>
                  )}
                </div>

                {/* Section Content - Only show when section is open */}
                {openSection === section.id && (
                  <div className="section-content mt-4">
                    {section.subSections ? (
                      section.subSections.map((subSection, subIndex) => (
                        <div key={`${section.id}-${subIndex}`} className="mb-4">
                          {subSection.title && (
                            <h4 
                              className="mb-3 fw-semibold" 
                              style={{ 
                                color: '#040695', 
                                fontSize: '1.5rem',
                                borderBottom: '2px solid #040695',
                                paddingBottom: '0.5rem'
                              }}
                            >
                              {subSection.title}
                            </h4>
                          )}
                          <Accordion 
                            open={openAccordion} 
                            toggle={toggleAccordion}
                            flush 
                            className="custom-accordion"
                          >
                            {subSection.questions.map((faq, faqIndex) => {
                              const accordionId = generateAccordionId(section.id, subIndex, faqIndex);
                              return (
                                <AccordionItem 
                                  key={accordionId}
                                  className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden"
                                >
                                  <AccordionHeader 
                                    targetId={accordionId}
                                    className="bg-white py-4 px-4 fw-bold fs-5"
                                  >
                                    {faq.q}
                                  </AccordionHeader>
                                  <AccordionBody 
                                    accordionId={accordionId}
                                    className="bg-light py-4 px-5"
                                    style={{ textAlign: 'justify' }}
                                  >
                                    {faq.a.split('\n').map((line, i) => (
                                      <p key={i} className="mb-2">{line}</p>
                                    ))}
                                  </AccordionBody>
                                </AccordionItem>
                              );
                            })}
                          </Accordion>
                        </div>
                      ))
                    ) : (
                      <Accordion 
                        open={openAccordion} 
                        toggle={toggleAccordion}
                        flush 
                        className="custom-accordion"
                      >
                        {section.questions.map((faq, faqIndex) => {
                          const accordionId = generateAccordionId(section.id, undefined, faqIndex);
                          return (
                            <AccordionItem 
                              key={accordionId}
                              className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden"
                            >
                              <AccordionHeader 
                                targetId={accordionId}
                                className="bg-white py-4 px-4 fw-bold fs-5"
                              >
                                {faq.q}
                              </AccordionHeader>
                              <AccordionBody 
                                accordionId={accordionId}
                                className="bg-light py-4 px-5"
                                style={{ textAlign: 'justify' }}
                              >
                                {faq.a.split('\n').map((line, i) => (
                                  <p key={i} className="mb-2">{line}</p>
                                ))}
                              </AccordionBody>
                            </AccordionItem>
                          );
                        })}
                      </Accordion>
                    )}
                  </div>
                )}
              </div>
            ))}
          </Col>
        </Row>
      </Container>

      {/* Custom Styling */}
      <style jsx>{`
        .cursor-pointer {
          cursor: pointer;
        }
        
        .section-header:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(4, 6, 149, 0.1);
        }
        
        .custom-accordion .accordion-button {
          background-color: white !important;
          color: #040695 !important;
          box-shadow: none !important;
          border-radius: 12px !important;
        }
        
        .custom-accordion .accordion-button:not(.collapsed) {
          background-color: #040695 !important;
          color: white !important;
        }
        
        .custom-accordion .accordion-button:focus {
          border-color: transparent;
          box-shadow: 0 0 0 3px rgba(4, 6, 149, 0.2);
        }
        
        .custom-accordion .accordion-button:not(.collapsed)::after {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
        }
        
        .custom-accordion .accordion-button::after {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23040695'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
        }
        
        .section-content {
          animation: fadeIn 0.3s ease;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Text justification for answers */
        .bg-light p {
          text-align: justify;
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
};

export default FAQ;